import React, {useEffect, useMemo, useState} from 'react';
import Layout from '../Shared/Layout';
import {
    CircularProgress,
    Container,
    Grid,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import styled from "styled-components";
import {Inertia} from "@inertiajs/inertia";

import FormPage from "../Shared/FormPage";
import {InertiaLink, useForm} from "@inertiajs/inertia-react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import TextField from "@material-ui/core/TextField";
import StatusFlow from "../Shared/StatusFlow/StatusFlow";
import MuiButton from "@material-ui/core/Button";
import FormField from "../Shared/FormField";
import {Button} from "../Shared/Button";
import {Field, Form as FinalForm} from "react-final-form";
import TextInput from "../Shared/TextInput";
import Select from "../Shared/Select";
import BackButton from "../Shared/BackButton";
import {getCookieValue} from "../utils/getCookieValue";
import DateSelect from "../Shared/DateSelect";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MuiSelect from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import timezones from 'timezones-list';
import {Trans} from "../utils/i18n";
import {InputAdornment, Tooltip} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import TabBar from "../Shared/TabBar";

const Wrapper = styled.div`
`;


const ButtonWrapper = styled.div`
  margin-top: 30px;
`;

const setInitialFormData = ({user, company}) => ({
    token: '',
    email: user.email,
    timezone: user.timezone,
    language: user.language,
    password: '',
    password_confirmation: '',
    company: company?.name,
    vat_number: company?.vat_number,
    shippingservice: company?.shippingservice,
    returnservice: company?.returnservice
});

export default function Profile({user, company, languages,}) {
    const {data, setData, post, processing, errors, reset} = useForm(setInitialFormData({user, company}));

    const handleSubmit = async e => {
        e.preventDefault();

        post(route('profile'), {
            onSuccess: (data) => {
                // Set new initial data based on the response.
                // Example: VAT number is stripped in backend.
                const formData = setInitialFormData({
                    user: data?.props?.user ?? user,
                    company: data?.props?.company ?? company
                });
                setData(formData);
            }
        });
    }

    return (
        <Wrapper>
            <Container maxWidth="md">
                <BackButton/>
                <h1><Trans i18nKey={'profile.title'}>Profile</Trans></h1>
                <TabBar tabs={[
                    {label: 'Settings', name: 'profile', current: true},
                    {label: 'Two Factor Authentication', name: 'profile.2fa', current: false},
                ]}/>

                <form onSubmit={handleSubmit}>
                    <TextField id="email" label={<Trans i18nKey="profile.email">E-Mail</Trans>} value={data.email}
                               onChange={e => setData('email', e.target.value)} name="email" type="email" required
                               error={errors.email} variant="filled" style={{marginBottom: '25px'}}/>
                    <TextField id="password" InputProps={
                        {
                            endAdornment:
                                <Tooltip title={<>
                                    <ul>
                                        <li><Trans i18nKey="password.tooltip.atleast_10_chars">At least 10
                                            characters</Trans></li>
                                        <li><Trans i18nKey="password.tooltip.lowercase">Lower case characters
                                            (a-z)</Trans></li>
                                        <li><Trans i18nKey="password.tooltip.uppercase">Upper case characters
                                            (A-Z)</Trans></li>
                                        <li><Trans i18nKey="password.tooltip.numbers">Numbers (0-9)</Trans></li>
                                        <li><Trans i18nKey="password.tooltip.special_chars">Special characters (e.g.
                                            @#$%^&amp;*()_+|~-=`{}[]:&quot;;&#039;&lt;&gt;/ etc)
                                        </Trans></li>
                                    </ul>
                                </>} arrow={true}>
                                    <InputAdornment position={"end"}><InfoIcon/></InputAdornment>
                                </Tooltip>
                        }
                    } label={<Trans i18nKey="profile.password">Password</Trans>} name="password" value={data.password}
                               onChange={e => setData('password', e.target.value)} type="password"
                               error={errors.password} variant="filled" style={{marginBottom: '25px'}}/>
                    <TextField id="password_confirmation"
                               label={<Trans i18nKey="profile.confirmPassword">Confirm Password</Trans>}
                               name="password_confirmation" value={data.password_confirmation}
                               onChange={e => setData('password_confirmation', e.target.value)} type="password"
                               error={errors.password_confirmation} variant="filled" style={{marginBottom: '25px'}}/>
                    <FormControl variant="outlined">
                        <InputLabel
                            htmlFor={'timezone'}>
                            <Trans i18nKey="profile.timezone">Timezone</Trans>
                        </InputLabel>
                        <MuiSelect
                            name={'timezone'}
                            // id={'select' + input.name }
                            native
                            label={<Trans i18nKey="profile.timezone">Timezone</Trans>}
                            value={data.timezone}
                            onChange={e => setData('timezone', e.target.value)}
                        >
                            {
                                timezones
                                    .map((item, index) => (
                                        <option key={index} value={item.tzCode}>{item.tzCode}</option>
                                    ))
                            }
                        </MuiSelect>
                    </FormControl>
                    <FormControl variant="outlined" style={{marginTop: 30, marginBottom: 25}}>
                        <InputLabel
                            htmlFor={'language'}>
                            <Trans i18nKey="profile.language">Language</Trans>
                        </InputLabel>
                        <MuiSelect
                            name={'language'}
                            // id={'select' + input.name }
                            native
                            label={<Trans i18nKey="profile.language">Language</Trans>}
                            value={data.language}
                            onChange={e => setData('language', e.target.value)}
                        >
                            {
                                languages
                                    .map((item, index) => (
                                        <option key={index} value={item.code}>{item.name}</option>
                                    ))
                            }
                        </MuiSelect>
                    </FormControl>
                    {company ?
                        <>
                            <TextField id="company" label={<Trans i18nKey="auth.register.company">Company</Trans>}
                                       value={data.company}
                                       onChange={e => setData('company', e.target.value)} name="company" type="text"
                                       required
                                       error={errors.company} variant="filled" style={{marginBottom: '25px'}}/>

                            <TextField id="vat_number"
                                       label={<Trans i18nKey="auth.register.vat_number">VAT number</Trans>}
                                       value={data.vat_number}
                                       onChange={e => setData('vat_number', e.target.value)} name="vat_number"
                                       type="text"
                                       required
                                       error={errors.vat_number} variant="filled" style={{marginBottom: '25px'}}/>

                            <FormControl variant="outlined" style={{marginTop: 30}}>
                                <InputLabel
                                    htmlFor={'shippingservice'}>
                                    <Trans i18nKey="auth.register.shippingservice">Shipping to repair
                                        courier</Trans>
                                </InputLabel>
                                <MuiSelect
                                    name={'shippingservice'}
                                    native
                                    label={<Trans i18nKey="auth.register.shippingservice">Shipping to repair
                                        courier</Trans>}
                                    value={data.shippingservice}
                                    onChange={e => setData('shippingservice', e.target.value)}
                                >
                                    {
                                        [
                                            {
                                                label: <Trans i18nKey="auth.register.shippingservice.retailer">By
                                                    retailer own transport</Trans>,
                                                value: "retailer",
                                            },
                                            {
                                                label: <Trans i18nKey="auth.register.shippingservice.b2x">By service
                                                    center transport</Trans>,
                                                value: "b2x",
                                            },
                                        ]
                                            .map((item, index) => (
                                                <option key={"shippingservice-" + index}
                                                        value={item.value}>{item.label}</option>
                                            ))
                                    }
                                </MuiSelect>
                            </FormControl>
                            <FormControl variant="outlined" style={{marginTop: 30}}>
                                <InputLabel
                                    htmlFor={'returnservice'}>
                                    <Trans i18nKey="auth.register.returnservice">Return to shop courier</Trans>
                                </InputLabel>
                                <MuiSelect
                                    name={'returnservice'}
                                    native
                                    label={<Trans i18nKey="auth.register.returnservice">Return to shop courier</Trans>}
                                    value={data.returnservice}
                                    onChange={e => setData('returnservice', e.target.value)}
                                >
                                    {
                                        [
                                            {
                                                label: <Trans i18nKey="auth.register.returnservice.customer">By retailer
                                                    own transport</Trans>,
                                                value: "customer",
                                            },
                                            {
                                                label: <Trans i18nKey="auth.register.returnservice.rsp">By service
                                                    center transport</Trans>,
                                                value: "rsp",
                                            },
                                        ]
                                            .map((item, index) => (
                                                <option key={"returnservice-" + index}
                                                        value={item.value}>{item.label}</option>
                                            ))
                                    }
                                </MuiSelect>
                            </FormControl>
                        </> : ''}
                    <ButtonWrapper>
                        <MuiButton type="submit" variant="contained" color="secondary">
                            {
                                !processing && <Trans i18nKey="profile.save">Save</Trans>
                            }
                            {
                                processing && <CircularProgress style={{height: 28, width: 28}}/>
                            }
                        </MuiButton>
                    </ButtonWrapper>
                    {
                        errors && errors.email && <p>{errors.email}</p>
                    }
                    {
                        errors && errors.password && <p>{errors.password}</p>
                    }
                </form>

            </Container>
        </Wrapper>
    )
}

Profile.layout = page => <Layout children={page}/>;
